import React from "react";

const IndicadoresSEO = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNDNkOWI3MGEtNDE0NC00NDI2LWFmNjQtNmIxZjk0MWM2MWVhIiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9&pageName=ReportSection" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default IndicadoresSEO;
